/**
 * OVERRIDE ListingBody.jsx
 */

import ListingBody from '../../../../../components/Blocks/Listing/ListingBody';

export default ListingBody;
